import { render, staticRenderFns } from "./VincularTecnico.vue?vue&type=template&id=63ebbed2&"
import script from "./VincularTecnico.vue?vue&type=script&lang=js&"
export * from "./VincularTecnico.vue?vue&type=script&lang=js&"
import style0 from "./VincularTecnico.vue?vue&type=style&index=0&id=63ebbed2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports